import React from "react";
import UserActivity from "../../types/admin/UserActivity";

import ActivityListItem from "./ActivityListItem";

type ActivityListItemGroupProps = {
    name: string,
    data: UserActivity[]
}

type ActivityListItemGroupState = {
    open: boolean
}

class ActivityListItemGroup extends React.Component<ActivityListItemGroupProps, ActivityListItemGroupState> {

    state = {
        open: false
    };

    getActiveCount() {
        return this.props.data
            .filter(item => item.systems
                .find(item => item.active)).length;
    }
    
    render() {

        return (
        <div className={`activity-list-group${this.state.open ? " open" : ""}`}>
            <div
                className="title row"
                tabIndex={0}
                onClick={() => this.setState(() => ({ open: !this.state.open }))}>
                <div className="col">
                    {this.props.name}
                </div>
                <div className="col">
                    Users: {this.props.data.length}, Active: {this.getActiveCount()}
                </div>
            </div>
            {this.props.data.map((activity, index) => 
                <ActivityListItem
                    key={activity?.user?.fullName ?? index}
                    data={activity} />)}
        </div>
        );

    }
}

export default ActivityListItemGroup;